<button
  class="btn"
  [attr.aria-label]="ariaText()"
  [class.disabledRegularState]="isDisabledRegularState()"
  [disabled]="isDisabled()"
  [ngClass]="buttonType()"
  [ngStyle]="{
    height: btnHeight() ? pxToRem(btnHeight() ?? 0) + 'rem' : null,
    paddingInline: btnPadding() ? pxToRem(btnPadding() ?? 0) + 'rem' : null,
    minWidth: btnMinWidth() ? pxToRem(btnMinWidth() ?? 0) + 'rem' : 'auto'
  }"
  (click)="onClickHandler()"
>
  <div class="text-and-icon" [ngClass]="{ reverse: isTextImageReverseOrder(), animated: isAnimated() }">
    @if (innerHtmlButtonText()) {
      <span class="text" [innerHTML]="innerHtmlButtonText()"></span>
    } @else {
      <span class="text">{{ text() }}</span>
    }
    @if (isLoading()) {
      <div class="spinner-icon">
        <pc-spinning-loader [isPrimaryColor]="isLoadingPrimaryColor()"></pc-spinning-loader>
      </div>
    } @else if (icon()) {
      <img
        class="icon"
        alt=""
        ngSrc="{{ icon() }}"
        [height]="height()"
        [ngClass]="{ 'filter-white': invertIconColor(), 'flip-icon': flipIcon() }"
        [width]="width()"
      />
    }
  </div>
</button>
